module.exports = __webpack_public_path__ + "static/img/a110.ebe08fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a110.jpg
// module id = sGUP
// module chunks = 0